import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { PremiumAccessDialogComponent } from './premium-access-dialog.component';

@NgModule({
  declarations: [PremiumAccessDialogComponent],
  imports: [CommonModule, MaterialModule, SharedModule, ReactiveFormsModule],
  exports: [PremiumAccessDialogComponent],
  entryComponents: [PremiumAccessDialogComponent],
})
export class PremiumAccessDialogModule {}
